import React from 'react';
import ExcelTableCell from './TableCell';
import CardStore from '../../stores/card';
import { observer } from 'mobx-react';
import ModeExcel from '../../stores/card/ModeExcel';
import CubeForm from '../../stores/form/form';
import _ from 'lodash';
import {modeForm} from '../../util/excelUtil';
import { getDomIdByFieldKey } from '../../util/typeUtil';
import {syncLockedForDidMount} from '../../util/excelUtil';
export interface ExcelTableTdsProps {
    row: number;
    form: CubeForm;
    card: CardStore;
    detail?: string;
    detailIndex?: number;
    excel: ModeExcel;
    isFixFieldDiv:boolean;
    rowspanJson?:any;
    isTitle:boolean;
}

@observer
export default class ExcelTableTds extends React.PureComponent<ExcelTableTdsProps, any> {



    componentDidMount(){
        const { detail,excel } = this.props;
        if(detail&&detail.indexOf("detail_") > -1){
            //明细锁定列同步一次高度
            const groupid = detail.replace('detail_', '');
            const supportLockedCol =  excel.edlockedcol||-1;
            if(supportLockedCol>-1)
            syncLockedForDidMount(groupid);
        }
    }

    render() {
        const { excel, row, form, card, detail,isFixFieldDiv ,rowspanJson={}, detailIndex = 0} = this.props;
        if(isFixFieldDiv){
            return (
                excel.getFixFieldTds(row,detail,excel.combineCell,excel.fixFieldIndex,detailIndex,rowspanJson).map(td => {
                    const verifyColor: any = {};
                    let domProps:any = {};
                    if (td && td.etype == '3' && form.has(td.getPath())) {
                        const color = form.$(td.getPath()).color;
                        if (color) {
                            _.set(verifyColor, "background", color);
                        }
                        const {etype} = td;
                        const path = td.getPath();
                        const bindObj = form.$(path);
                        let fieldName = getDomIdByFieldKey(bindObj.path);
                        let fieldMark = fieldName; 
                        if(etype == "3"){ //字段
                            domProps.onClick = () =>{modeForm.triggerFieldAction("onclick",fieldMark)};
                            domProps.onDoubleClick = () =>{modeForm.triggerFieldAction("ondbclick",fieldMark)};
                            domProps.onMouseOver = () =>{modeForm.triggerFieldAction("mouseover",fieldMark)};
                            domProps.onMouseOut = () =>{modeForm.triggerFieldAction("mouseout",fieldMark)};
                        }
                    }
                    if(detail){                
                        return (
                            td ? <td {...domProps} style={{ ...td.style, ...verifyColor,display:td.hidechild&&td.hidechild==="y"?"none":""}} {...td.otherProps} >
                                <ExcelTableCell ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCell@vcjx4u@${detailIndex}`} cell={td} form={form} excel={excel} card={card} detail={detail} index={detailIndex}/>
                            </td> : <td/>
                        )
                    }
                })
            )
        }
        return (
            excel.getTds(row,detail,excel.combineCell,detailIndex,rowspanJson).map((td,index) => {
                const verifyColor: any = {};
                let domProps:any = {};
                if (td && td.etype == '3' && form.has(td.getPath())) {
                    const color = form.$(td.getPath()).color;                
                    if (color) {
                        _.set(verifyColor, "background", color);
                    }
                    const {etype} = td;
                    const path = td.getPath();
                    const bindObj = form.$(path);
                    let fieldName = getDomIdByFieldKey(bindObj.path);
                    let fieldMark = fieldName; 
                    if(etype == "3"){ //字段
                        domProps.onClick = ()=> modeForm.triggerFieldAction("onclick",fieldMark);
                        domProps.onDoubleClick = ()=> modeForm.triggerFieldAction("ondbclick",fieldMark);
                        domProps.onMouseOver = ()=> modeForm.triggerFieldAction("mouseover",fieldMark);
                        domProps.onMouseOut =()=>  modeForm.triggerFieldAction("mouseout",fieldMark);
                    }
                }
                if(detail){    
                    return (
                        td ? <td {...domProps} style={{ ...td.style, ...verifyColor,display:td.hidechild&&td.hidechild==="y"?"none":"" }} {...td.otherProps} >
                        <ExcelTableCell ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCell@ugxhpb@${detailIndex}`} cell={td} form={form} excel={excel} card={card} detail={detail} index={detailIndex}/>
                        </td> : <td />
                    )
                }
                if(td && td.etype == "6"){
                   //  excel设计器插入单元格  图片，插入背景图处理
                    return  td ? <td  style={{ ...td.style, ...verifyColor,backgroundImage:`url(${td.field})` }} {...td.otherProps} >
                    <div style={{width:"100%",display:td.hidechild&&td.hidechild==="y"?"none":""}}>
                        {td.evalue?td.evalue:""}
                    </div>
                </td> : <td />
                }
                return (
                    td ? <td  style={{ ...td.style, ...verifyColor }} {...td.otherProps} >
                        <div {...domProps} style={{width:"100%",display:td.hidechild&&td.hidechild==="y"?"none":""}}>
                            <ExcelTableCell ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCell@frvkko@${detailIndex}`} cell={td} form={form} excel={excel} card={card} detail={detail} index={detailIndex}/>
                        </div>
                    </td> : <td />
                )
            })
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/TableTds.tsx